import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetalleOtComponent } from './detalle-ot.component';
import { Routes, RouterModule } from '@angular/router';
import { NgxPermissionsModule } from 'ngx-permissions';
import { MaterialModule } from '../../../../components/material/material.module';
import { BotonToggleModule } from '../../../../components/boton/boton-toggle.module';
import { VolverModule } from '../../../../components/volver/volver.module';
import { PipesModule } from '../../../../pipes/pipes.module';
import { ProductoOtModule } from '../../../../forms/ot/producto-ot/producto-ot.module';
import { ArchivoModule } from '../../../../components/archivo/archivo.module';
import { OtModule } from '../../../../forms/ot/ot.module';
import { BotonActionModule } from '../../../../components/boton-action/boton-action.module';
import { ConfirmModule } from '../../../../components/confirm/confirm.module';

const routes: Routes = [
  {
    path: '',
    component: DetalleOtComponent
  }
];

@NgModule({
  declarations: [
    DetalleOtComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    NgxPermissionsModule.forChild(),
    MaterialModule,
    BotonToggleModule,
    VolverModule,
    PipesModule,
    ProductoOtModule,
    ArchivoModule,
    OtModule,
    BotonActionModule,
    ConfirmModule,
  ]
})
export class DetalleOtModule { }